<app-base-action-modal
  [modalTitle]="fileName$ | async"
  [hideSecondary]="hasErrors$ | async"
  [primaryLabel]="primaryLabel$ | async"
  secondaryLabel="Discard Upload"
  i18n-secondaryLabel
  (closeClicked)="closeClicked()"
  (secondaryClicked)="close({ discardUpload: true })"
  (primaryClicked)="primaryClicked()"
  [secondaryButtonStyle]="SecondaryButtonStyleEnum.Secondary">
  <div class="member-preview-table">
    <div *ngIf="!(hasErrors$ | async)" class="preview-text" i18n>
      Review the preview file data to ensure the column headers are positioned with the correct table cells. If not,
      you’ll need to adjust your data entries and upload them again. You may edit employee information in the next step.
    </div>
    <div *ngIf="hasErrors$ | async" class="d-flex flex-column">
      <div class="d-flex gap-2 mb-2">
        <img src="assets/icons/dark/Circle-Error.svg" />
        <span class="error-header" i18n>Upload Issues Detected</span>
      </div>
      <span class="subtitle mb-3" i18n>Please review the details below and update the file before trying again.</span>
      <ng-container *ngIf="(invalidRows$ | async)?.length && (invalidRows$ | async)?.length <= 10">
        <div class="d-flex flex-column">
          <span class="subtitle mb-2" i18n>The following rows have missing or invalid data:</span>
          <ul>
            <li i18n>Rows: {{ (invalidRows$ | async) ?? [] | join }}</li>
          </ul>
        </div>
        <div>
          <span class="subtitle mb-2" i18n>
            The following columns contain values that do not meet expected formats:
          </span>
          <ul>
            <li *ngFor="let column of invalidColumns$ | async | keyvalue">
              {{ column.key !== 'SIN' ? (column.key | humanReadable) : column.key }}
            </li>
          </ul>
        </div>
      </ng-container>

      <div *ngIf="(invalidRows$ | async)?.length > 10">
        <span class="subtitle" i18n>
          Issues found in {{ (invalidRows$ | async)?.length }} rows across the following columns:
        </span>
        <ul>
          <li *ngFor="let column of invalidColumns$ | async | keyvalue">
            {{ column.key !== 'SIN' ? (column.key | humanReadable) : column.key }}: ({{
              column.value?.rowsWithErrors?.length
            }})
          </li>
        </ul>
      </div>
    </div>
    <app-batch-add-member-file-preview-table
      [records]="records$ | async"
      (invalidRows)="setInvalidRows($event)"
      (invalidColumns)="setInvalidColumns($event)" />
    <app-batch-add-members-file-requirements *ngIf="hasErrors$ | async" />
  </div>
</app-base-action-modal>
